import { render, staticRenderFns } from "./ZoomImg.vue?vue&type=template&id=43dc3bb6&"
import script from "./ZoomImg.vue?vue&type=script&lang=ts&"
export * from "./ZoomImg.vue?vue&type=script&lang=ts&"
import style0 from "./ZoomImg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports